// Galeria Belo Horizonte Residences — imagens oficiais do projeto (webp local)
export const GALLERY = [
  { src: "/assets/gallery/g01.webp", alt: "Vista exterior do Belo Horizonte Residences", span: "tall" },
  { src: "/assets/gallery/g02.webp", alt: "Edifício com vista para o rio Sado e a Serra da Arrábida", span: "wide" },
  { src: "/assets/gallery/g03.webp", alt: "Entrada do empreendimento", span: "normal" },
  { src: "/assets/gallery/g04.webp", alt: "Terraço panorâmico com vista para o estuário", span: "tall" },
  { src: "/assets/gallery/g05.webp", alt: "Vista aérea de Setúbal", span: "wide" },
  { src: "/assets/gallery/g06.webp", alt: "Piscina exterior e zona de lazer", span: "normal" },
  { src: "/assets/gallery/g07.webp", alt: "Ginásio totalmente equipado", span: "normal" },
  { src: "/assets/gallery/g08.webp", alt: "Lounge interior com jardim", span: "wide" },
  { src: "/assets/gallery/g09.webp", alt: "Sala de bilhar", span: "tall" },
  { src: "/assets/gallery/g10.webp", alt: "Bar e zona social", span: "normal" },
  { src: "/assets/gallery/g11.webp", alt: "Sala de jogos com ténis de mesa", span: "normal" },
  { src: "/assets/gallery/g12.webp", alt: "Interior de apartamento — sala e cozinha", span: "tall" },
  { src: "/assets/gallery/g13.webp", alt: "Suite com zona de estar", span: "normal" },
  { src: "/assets/gallery/g14.webp", alt: "Cozinha e espaço de coworking", span: "normal" },
  { src: "/assets/gallery/g15.webp", alt: "Vista aérea do empreendimento", span: "wide" },
  { src: "/assets/gallery/g16.webp", alt: "Esplanada com vista para o rio Sado e a Serra da Arrábida", span: "tall" },
  { src: "/assets/gallery/g17.webp", alt: "Jardins e arte exterior", span: "normal" },
  { src: "/assets/gallery/g18.webp", alt: "Casa de banho contemporânea", span: "normal" },
];
